import { Navigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";

const GuestRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    const step = user?.onboarding_steps;

    if (step === 7) {
      return <Navigate to="/onboard/upload" replace />;
    } else if (step < 7) {
      return <Navigate to={`/onboard#${step}`} replace />;
    }

    return <Navigate to="/explore" replace />;
  }

  return children;
};

export default GuestRoute;
